import React from 'react';

import { FeaturePatternTrussSettings } from '@paragon/contract-library';

import { loadFeaturePatternSettings } from '../../../../../store/actions/loadActions';
import { saveFeaturePatternSettings } from '../../../../../store/actions/settingsActions';
import { settingsShouldBeViewOnly } from '../../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import SettingsPanelContainer, { connectSettingsPanelContainer } from '../SettingsPanelContainer';
import { FeaturePatternSettingsControls } from './FeaturePatternSettingsControls';

const FeaturePatternSettingsContainer = connectSettingsPanelContainer(
  class extends SettingsPanelContainer<FeaturePatternTrussSettings> {},
);

const INSERTION_SETTINGS_MESSAGE =
  'Not supported.  Feature Pattern Settings for an insertion component should be edited in the insertion panel.';
const INSERTION_MODE_HANDLER = () => {
  throw new Error(INSERTION_SETTINGS_MESSAGE);
};

export function FeaturePatternSettingsPanel() {
  const dispatch = useAppDispatch();

  const isViewOnly = useAppSelector(settingsShouldBeViewOnly);

  return (
    <FeaturePatternSettingsContainer
      isViewOnly={isViewOnly}
      controls={FeaturePatternSettingsControls}
      fetchSettings={{
        fromInsertionInfo: INSERTION_MODE_HANDLER,
        fromSettingsDatabase: (modelGuid: string) => dispatch(loadFeaturePatternSettings(modelGuid)),
      }}
      disableSavingActualSettings
      onSave={{
        forInsertionComponent: INSERTION_MODE_HANDLER,
        forExistingModel: (settings, options) => dispatch(saveFeaturePatternSettings(settings, options)),
      }}
    />
  );
}
